export class FormFieldBase<T> {
    type: string;
    value?: T;
    key: string;
    label: string;
    order: number;
    controlType: string;
    extra: string;
    width: number;
    height: number;
    description: string;

    options: { key: string, value: string }[] = [];
    pattern: string;
    required: boolean;
    validationText: string;

    formId: string;

    constructor(
        options: {
            formId?: string,
            value?: T,
            key?: string,
            label?: string,
            required?: boolean,
            order?: number,
            controlType?: string,
            extra?: string,
            width?: number,
            height?: number,
            pattern?: string,
            description?: string,
            other?: string,
            validationText?: string;
        } = { }) {

        this.formId = options.formId || "";
        this.value = options.value;
        this.key = options.key || "";
        this.label = options.label || "";
        this.order = options.order === undefined ? 1 : options.order;
        this.controlType = options.controlType || "";
        this.extra = options.extra || "";
        this.width = options.width;
        this.height = options.height;
        this.required = !!options.required;
        this.pattern = options.pattern || "";
        this.description = options.description || "";
        this.validationText = options.validationText || "";
    }

    resetToDefault(): void {}
}

export class FormFieldAttachFileButton extends FormFieldBase<string> {
    controlType: string = "buttonAttachFile";
    type: string = "file";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class FormFieldAttachImageButton extends FormFieldBase<string> {
    controlType: string = "buttonAttachImage";
    type: string = "file";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class FormFieldCaptcha extends FormFieldBase<string> {
    controlType: string = "captcha";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class FormFieldChoice extends FormFieldBase<string> {
    controlType: string = "choice";
    options: { key: string, value: string }[] = [];

    constructor(options: {} = {}) {
        super(options);
        this.options = options["options"] || [];
        this.setDefault();
    }

    resetToDefault(): void {
        this.setDefault();
    }

    private setDefault(): void {
        if (this.options.length > 0) {
            this.value = this.options[0].value;
        }
    }
}

export class FormFieldClearButton extends FormFieldBase<string> {
    controlType: string = "buttonClear";
    type: string = "reset";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class FormFieldDate extends FormFieldBase<string> {
    controlType: string = "date";
    type: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options["type"] || "";
    }
}

export class FormFieldDescription extends FormFieldBase<string> {
    controlType: string = "description";
    type: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options["type"] || "";
    }
}

export class FormFieldEmail extends FormFieldBase<string> {
    controlType: string = "email";
    type: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options["type"] || "";
    }
}

export class FormFieldFailureMessage extends FormFieldBase<string> {
    controlType: string = "msgFailure";
    type: string;
    targetPageId: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options["type"] || "";
    }
}

export class FormFieldHeading extends FormFieldBase<string> {
    controlType: string = "heading";
    type: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options["type"] || "";
    }
}

export class FormFieldHidden extends FormFieldBase<string> {
    controlType: string = "hidden";
    type: string = "hidden";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class FormFieldMultiLineText extends FormFieldBase<string> {
    controlType: string = "multiLineText";
    type: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options["type"] || "";
    }
}

export class FormFieldNumber extends FormFieldBase<string> {
    controlType: string = "number";

    constructor(options: {} = {}) {
        super(options);
        this.type = options["type"] || "";
    }
}

export class FormFieldPassword extends FormFieldBase<string> {
    controlType: string = "password";
    type: string = "password";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class FormFieldResetPasswordButton extends FormFieldBase<string> {
    controlType: string = "buttonResetPassword";
    type: string = "submit";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class FormFieldSubmitAndClearButtons extends FormFieldBase<string> {
    controlType: string = "buttonSubmitAndClear";
    targetPageId: string;

    constructor(options: {} = {}) {
        super(options);
        this.targetPageId = options["targetPageId"] || "";
    }
}

export class FormFieldSubmitButton extends FormFieldBase<string> {
    controlType: string = "buttonSubmit";
    type: string = "submit";
    targetPageId: string;

    constructor(options: {} = {}) {
        super(options);
        this.targetPageId = options["targetPageId"] || "";
    }
}

export class FormFieldCheckIdentityButton extends FormFieldBase<string> {
    controlType: string = "buttonCheckIdentity";
    type: string = "submit";
    targetPageId: string;
    key: string = "checkIdentity";

    constructor(options: {} = {}) {
        super(options);
        this.targetPageId = options["targetPageId"] || "";
    }
}

export class FormFieldVerifyIdentityButton extends FormFieldBase<string> {
    controlType: string = "buttonCheckIdentity";
    type: string = "submit";
    targetPageId: string;
    key: string = "verifyIdentity";

    constructor(options: {} = {}) {
        super(options);
        this.targetPageId = options["targetPageId"] || "";
    }
}

export class FormFieldIdentityValidation extends FormFieldBase<string> {
    controlType: string = "singleLineText";
    type: string;

    validationErrorMessage: string = this.key + " is required.";

    constructor(options: {} = {}) {
        super(options);
        this.type = options["type"] || "";
    }
}

export class FormFieldSingleLineText extends FormFieldBase<string> {
    controlType: string = "singleLineText";
    type: string;

    validationErrorMessage: string = this.key + " is required.";

    constructor(options: {} = {}) {
        super(options);
        this.type = options["type"] || "";
    }
}

export class FormFieldSpecial extends FormFieldBase<string> {
    controlType: string = "special";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class FormFieldSuccessMessage extends FormFieldBase<string> {
    controlType: string = "msgSuccess";
    type: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options["type"] || "";
    }
}

export class FormFieldValidationLink extends FormFieldBase<string> {
    controlType: string = "msgValidationLink";
    type: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options["type"] || "";
    }
}

export class FormFieldEmailSubject extends FormFieldBase<string> {
    controlType: string = "msgEmailSubject";
    type: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options["type"] || "";
    }
}

export class FormFieldEmailConfirm extends FormFieldBase<string> {
    controlType: string = "msgEmailConfirm";
    type: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options["type"] || "";
    }
}

export class FormFieldYesNo extends FormFieldBase<string> {
    controlType: string = "yesno";

    constructor(options: {} = {}) {
        super(options);
    }
}
